/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Op_SuccessInputs */



/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Admin_Op_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_op_success = /** @type {((inputs?: Admin_Op_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Op_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Completado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Concluído")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completato")
	return /** @type {LocalizedString} */ ("Completed")
});